<template>
<i class="options icon-dots-vertical" @click="Options([
    // {text: 'Instalar SSL', function: () => {CreateSSLEntry()}, confirm: 'Se instalará un certificado SSL del dominio configurado. El dominio debe estar previamente funcionando (DNS propagados).'},
    {text: 'Crear Dominio', function: () => {UpdateDomain()}, confirm: `Se crearán las entradas del dominio en el servidor y certificado SSL.`, icon: 'cog'},
])"></i>
</template>

<script>
export default {
    props: {
        domain: '',
    },
    methods: {
        UpdateDomain()
        {
            if(!this.Util.IsValidInfluyeDomain(this.domain)) return this.Info('Dominio inválido');
            this.Loading();
            axios.put(`/influye/domains/update`, {domain: this.domain}).then(res => {
                this.Info('Se han creado las configuraciones en el servidor para el dominio');
            }).catch(err => {
                this.Response(err);
            });
        },
        CreateSSLEntry()
        {
            if(!this.Util.IsValidInfluyeDomain(this.domain)) return this.Info('Dominio inválido');
            this.Loading();
            axios.put(`/influye/domains/ssl`, {domain: this.domain}).then(res => {
                this.Info('Se instalará un certificado SSL para el dominio');
            }).catch(err => {
                this.Response(err);
            });
        },
    }
}
</script>

<style>

</style>